import { useState } from 'react'

import { useUserInfo } from 'src/hooks/useUserInfo'
import { useManageUserCars } from 'src/hooks/useManageUserCars'
import { useGetActualCurrencyOneInch } from 'src/hooks/useGetActualCurrencyOneInch'
import useAuthListener from 'src/hooks/useAppAuthListener'

export const useApp = () => {
  useManageUserCars()
  useAuthListener()
  useGetActualCurrencyOneInch()
  useUserInfo()

  const [isOpen, setIsOpen] = useState(true)

  const toggleSideBar = (): void => {
    setIsOpen(prevState => !prevState)
  }

  return { isOpen, setIsOpen, toggleSideBar }
}
